import React, { useEffect } from 'react';
import { Route, Redirect, RouteProps, RouteComponentProps } from 'react-router-dom';
import Notification from '../components/Ant/Notification';

import { APICore } from '../helpers/api/apiCore';
import { isEven } from '../utils/isEven';
import { useGetQuery } from '../frameWork/rest';
import { API_ENDPOINTS } from '../frameWork/utils/keyapi-endpoints';
interface PrivateRouteProps {
    component: React.FunctionComponent<RouteProps>;
    roles?: string;
    requiredScopes?: string[];
}

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRouteShareLinkComponent = ({ props,requiredScopes,Component }: any) => {
    const api = new APICore();
  const { isLoading: isloading, data: s_IsLogin, refetch: getShareLogin } = useGetQuery(API_ENDPOINTS.SHARELINK_SHARELOGIN, "ShareLogin",props.location?.search?.split('?data=')[1]?.toString()?.trim() );

  useEffect(()=>{
    const s=async()=>
        {
            await getShareLogin()
        }
    
s();
},[props.location])

    // let s_IsLogin = false;
    //             const s_CheckLogin = props.location.search.split('ebn8-')
    //             if (s_CheckLogin?.length > 1) {
    //                 const s_LoginNumber = s_CheckLogin[0]?.split('?data=')
    //                 if (s_LoginNumber?.length > 1) {
    //                     if (isEven(s_LoginNumber[1].toString().trim()))
    //                         s_IsLogin = true;
    //                 }

                    if (s_IsLogin==="1") {
                        if (api.isUserAuthenticated() === false) {
                            // not logged in so redirect to login page with the return url
                            return (
                                <Redirect
                                    to={{
                                        pathname: '/auth/login',
                                        state: { from: props.location },
                                    }}
                                />
                            );
                        }

                        if (api.isUserAllowed(requiredScopes) === false) {

                            // not logged in so redirect to login page with the return url
                            return (


                                <Notification title="عدم دسترسی" message="شما مجوز مشاهده و استفاده از این صفحه را ندارید" />

                                //messageApi.info('Hello, Ant Design!')

                            );

                            // return;
                        }
                    }
                

    return (

        
            
                
                
                // authorised so return component
                 <Component {...props} />
            
        
    );
};

export default PrivateRouteShareLinkComponent;
